import React from 'react';
import { Card } from 'antd';

const AnalyticsCard = ({ children, title, ...props }) => {
    return (
        <Card
            title={title}
            {...props}
            style={{
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, .1)',
                border: 'none',
                ...props.style
            }}
            bodyStyle={{
                padding: '24px',
                ...props.bodyStyle
            }}
            headStyle={{
                borderBottom: title ? '1px solid #f0f0f0' : 'none',
                padding: title ? '16px 24px' : '0',
                ...props.headStyle
            }}
        >
            {children}
        </Card>
    );
};

export default AnalyticsCard;
